import {Button, ButtonProps} from '@/shadcn_components/ui/button';
import {TrashIcon} from 'lucide-react';

export const DeleteIconButton = (props: Partial<ButtonProps>) => (
  <Button
    variant="ghost"
    size="icon"
    className="px-1 py-1 rounded-md text-red-600 hover:bg-red-50 hover:border-red-600 hover:border hover:text-red-600"
    {...props}>
    <TrashIcon className="w-4 h-4" />
  </Button>
);
